import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { WithTooltip } from '../RemoteVisualization/WithTooltip';
export const RemoteConsumesFilesLinksRenderer = (param)=>{
    let { value } = param;
    if (!value.length) {
        return /*#__PURE__*/ _jsx(_Fragment, {});
    }
    return /*#__PURE__*/ _jsx("div", {
        className: "flex flex-col items-center justify-center py-3 gap-1",
        children: value.map((param)=>{
            let { name, url } = param;
            return /*#__PURE__*/ _jsx(WithTooltip, {
                name: name,
                children: /*#__PURE__*/ _jsx("a", {
                    href: url,
                    target: "_blank",
                    rel: "noreferrer",
                    className: "text-primary hover:underline",
                    children: name
                })
            }, name);
        })
    });
};
